import React from 'react';
import { Banner } from '../../../../models';
import CloseButton from './CloseButton';
import styles from '../StaticBanner.module.scss';

type Props = {
    banner: Banner;
    onClose: () => void;
}

const ImageOnlyBanner: React.FC<Props> = ({ banner, onClose }) => {
    return (
        <div className={styles.bannerImage}>
            <img
                src={banner.imageUrl!}
                alt={banner.title || ''}
                title={banner.title || ''}
                className={styles.image}
            />
            {banner.staticHideable && (
                <CloseButton onClick={onClose} />
            )}
        </div>
    );
};

export default ImageOnlyBanner;
